module.exports = __webpack_public_path__ + "static/media/spring-2021-virtual.67a77b25.jpg";